import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function GiveawayTitleModal({
  visible,
  defaultTitle,
  onConfirm,
  onCancel,
}) {
  const [title, setTitle] = useState(defaultTitle);
  const inputRef = useRef(null);

  useEffect(() => {
    setTitle(defaultTitle);
  }, [defaultTitle, visible]);

  useEffect(() => {
    if (!visible) return;

    const frameId = requestAnimationFrame(() => {
      inputRef.current?.focus();
      inputRef.current?.select();
    });

    return () => cancelAnimationFrame(frameId);
  }, [visible]);

  if (!visible) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm(title.trim());
  };

  return createPortal(
    <div>
      <div
        onClick={onCancel}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(2, 10, 30, 0.78)",
          backdropFilter: "blur(4px)",
          zIndex: 1300,
        }}
      />

      <div
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1301,
          pointerEvents: "none",
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{
            width: "min(440px, calc(100vw - 32px))",
            borderRadius: 18,
            background: "linear-gradient(160deg, rgba(10, 35, 70, 0.97) 0%, rgba(5, 20, 50, 0.98) 100%)",
            border: "1px solid rgba(80, 180, 255, 0.4)",
            boxShadow: "0 0 40px rgba(0, 150, 255, 0.25), 0 8px 24px rgba(0, 0, 0, 0.7)",
            padding: 24,
            color: "#e0f7fa",
            pointerEvents: "auto",
            boxSizing: "border-box",
          }}
          onClick={(event) => event.stopPropagation()}
        >
          <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 8, color: "#40e8ff" }}>
            Giveaway Title
          </div>
          <div style={{ fontSize: 14, lineHeight: 1.5, color: "rgba(214, 232, 255, 0.84)", marginBottom: 16 }}>
            Choose the title that will be stored with this giveaway result.
          </div>

          <input
            ref={inputRef}
            type="text"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            placeholder="Giveaway title"
            className="login-input"
            style={{ marginBottom: 18 }}
          />

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button type="button" className="names-btn secondary" onClick={onCancel}>Cancel</button>
            <button type="submit" className="names-btn primary">Submit</button>
          </div>
        </form>
      </div>
    </div>,
    document.body,
  );
}